import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { connect } from 'react-redux';
import moment from 'moment';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setTenant } from '../redux/auth/auth.action';
import { getAnalyticsData } from '../services/analytics';
import { getTenantData } from '../services/tenant';
import noUser from '../assets/img/no_user.jpg';
import { searchContacts } from '../services/contacts';
import { galleryAnalytics, getGalleryImage } from '../services/gallery';
import TableComponent from '../comman/component/table';
import useExportData from 'hooks/useExportData';
import { formatPhoneDisplay } from 'helper/phone';

import FooterEnd from 'comman/component/footerEnd';
const detailsPerPage = 6;
let arrayForHoldingInfo = [];

const optionFilterOneTap = [
  { label: 'Total calls', value: 'all' },
  {
    label: 'Successful calls',
    value: 'successful',
  },
  {
    label: 'Unsuccessful calls',
    value: 'unsuccessful',
  },
  {
    label: '1-Tap Actions',
    value: 'oneTap',
  },
  {
    label: 'Interactions',
    value: 'interactions',
  },
];
const Index = ({ tenantId, setTenant, userRole, totalPercentage }) => {
  // console.log('totalPercentage', totalPercentage);
  const [startDate, setStartDate] = useState(
    new Date(moment().startOf('month'))
  );
  const [endDate, setEndDate] = useState(new Date());
  const [filterOneTap, setFilterOneTap] = useState(optionFilterOneTap[0]);

  const { handleExport: handleExportGraph } = useExportData({
    columns: [
      {
        name: 'Phone',
        key: 'phoneNumber',
      },
      // {
      //   name: 'Percentage Connected',
      //   key: 'percent',
      // },
      {
        name: 'Total call',
        key: 'total',
      },
      {
        name: 'Date',
        key: 'date',
      },
    ],
    filename: `statistical_${filterOneTap.value}_${moment(startDate).format(
      'MM-DD-YYYY'
    )}_${moment(endDate).format('MM-DD-YYYY')}`,
  });

  const { handleExport: handleExportAnswerRate } = useExportData({
    columns: [
      {
        name: 'Phone',
        key: 'phoneNumber',
      },
      {
        name: 'Total calls',
        key: 'total',
      },
      {
        name: 'Android',
        key: 'totalAndroid',
      },
      {
        name: 'IOS',
        key: 'totalIOS',
      },
      {
        name: 'Successful Calls',
        key: 'totalSuccessful',
      },
      {
        name: 'Unsuccessful Calls',
        key: 'totalUnSuccessful',
      },

      {
        name: 'Successful percent(%)',
        key: 'successfulPercent',
      },
      {
        name: 'Unsuccessful percent(%)',
        key: 'unSuccessfulPercent',
      },
      {
        name: '1-Tap Total',
        key: 'totalLink',
      },
      {
        name: '1-Tap percent(%)',
        key: 'percentOne',
      },
      {
        name: 'Interaction',
        key: 'successCallInteraction',
      },
      {
        name: 'Interaction Rate(%)',
        key: 'successCallInteractionPercent',
      },
      // {
      //   name: '1-Tap Auto Declined',
      //   key: 'autoDeclined',
      // },

      // {
      //   name: '1-Tap Do Nothing percent(%)',
      //   key: 'percentOne',
      // },
      // {
      //   name: '1-Tap Auto Received percent(%)',
      //   key: 'percentAutoAccepted',
      // },
      // {
      //   name: '1-Tap Auto Declined percent(%)',
      //   key: 'percentAutoDeclined',
      // },

      // oneTap,
      //     autoAccepted,
      //     autoDeclined,
      //     totalLink,
      //     percentOne,
      //     percentAutoAccepted,
      //     percentAutoDeclined
      {
        name: 'Date',
        key: 'date',
      },
    ],
    filename: `Answer_Rates_${moment(startDate).format('MM-DD-YYYY')}_${moment(
      endDate
    ).format('MM-DD-YYYY')}`,
  });

  const [isLoadingFilter, setIsLoadingFilter] = useState(false);

  const [accountInformation, setAccountInformation] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [contactImages, setContactImages] = useState({});
  const [lineGraph, setLineGraph] = useState();
  const [optionGraph, setOptionGraph] = useState();
  const [galleryAnalyticTable, setGalleryAnalyticTable] = useState([]);
  const [selectedContact, setSelectedContact] = useState([]);
  const [callSuccessRete, setCallSuccessRate] = useState();
  const [callUnsuccessRete, setCallUnsuccessRate] = useState();
  const [contactArray, setContactArray] = useState([]);
  const [callCount, setCallCount] = useState({
    total: 0,
    successFull: 0,
    unSuccessFull: 0,
    oneTap: 0,
    autoAccepted: 0,
    autoDeclined: 0,
    successCallInteraction: 0,
  });
  const [analyticsData, setAnalyticsData] = useState();

  const loopWithSlice = (start, end) => {
    if (accountInformation) {
      const slicedInfo = accountInformation.slice(start, end);
      arrayForHoldingInfo = [...arrayForHoldingInfo, ...slicedInfo];
    }
  };

  useEffect(() => {
    arrayForHoldingInfo = [];
    loopWithSlice(0, detailsPerPage);
    // eslint-disable-next-line
  }, [accountInformation]);

  useEffect(() => {
    if (userRole && userRole === 'Administrator' && tenantId) {
      (async () => {
        const response = await getTenantData(tenantId);
        await setTenant(response.data);
      })();
    }
    fetchContactDetails();
    getAnalytics();
    // eslint-disable-next-line
  }, [tenantId]);

  useEffect(() => {
    setCallSuccessRate(
      callCount.successFull > 0
        ? ((callCount.successFull * 100) / callCount.total).toFixed(2)
        : 0
    );
    setCallUnsuccessRate(
      callCount.unSuccessFull > 0
        ? ((callCount.unSuccessFull * 100) / callCount.total).toFixed(2)
        : 0
    );
  }, [callCount]);

  const dataTotalFilter = (item) => {
    // if (filterOneTap.value === 'successful') {
    //   return item.totalSucceededCalls;
    // }

    // if (filterOneTap.value === 'unsuccessful') {
    //   return item.totalFailedCalls;
    // }

    // // totalFailedCalls
    //       // totalSucceededCalls

    // if (filterOneTap.value === 'oneTap') {
    //   return (
    //     item.linkActionType?.oneTap +
    //     item.linkActionType?.autoAccepted +
    //     item.linkActionType?.autoDeclined
    //   );
    // }
    // if (filterOneTap.value === 'interactions') {
    //   const successCallItem = item.totalSucceededCalls;
    //   return successCallItem * 2 + item.linkActionType?.oneTap +
    //         item.linkActionType?.autoAccepted +
    //         item.linkActionType?.autoDeclined
    //   // return successCallItem
    //   //   ? successCallItem + item.linkActionType?.oneTap +
    //   //       item.linkActionType?.autoAccepted +
    //   //       item.linkActionType?.autoDeclined
    //   //   : 0;
    // }

    return item.Total;
  };
  const dataTotalGraph = (item) => {
    if (filterOneTap.value === 'successful') {
      return item.totalSucceededCalls * 2;
    }

    if (filterOneTap.value === 'unsuccessful') {
      return item.totalFailedCalls * 2;
    }

    // // totalFailedCalls
    //       // totalSucceededCalls

    if (filterOneTap.value === 'oneTap') {
      return (
        item.linkActionType?.oneTap +
        item.linkActionType?.autoAccepted +
        item.linkActionType?.autoDeclined
      );
    }
    if (filterOneTap.value === 'interactions') {
  const successCallItem = item.totalSucceededCalls;
  return (
    (successCallItem * 2) + // Nhân đôi successful calls ở đây
    item.linkActionType?.oneTap +
    item.linkActionType?.autoAccepted +
    item.linkActionType?.autoDeclined
  );
}



    return item.Total * 2;
  };

  const getAnalytics = async () => {
    const queryStartDate = moment(startDate).startOf('day');
    const queryEndDate = moment(endDate).endOf('day');
    const currentOffset = moment().utcOffset();
    const queryData = {
      startTime: moment(queryStartDate).add('m',currentOffset).format('x'),
      endTime: moment(queryEndDate).add('m',currentOffset).format('x'),
      // startTime: moment(queryStartDate).format('x'),
      // endTime: moment(queryEndDate).format('x'),
      timezone: 'UTC',
    };
    


    const response = await getAnalyticsData(queryData);

    let dayLabels = [];
    let callData = [];
    let successCall = 0;
    let unSuccessCall = 0;
    let autoAccepted = 0;
    let autoDeclined = 0;
    let oneTap = 0;

    let successCallInteraction = 0;
    let stepSizeForY = 2;
    if (response.status === 200) {
      let sortData = response.data.objects.sort((a, b) => {
        const date1 = Date.parse(a.day);
        const date2 = Date.parse(b.day);
        return date1 - date2;
      });
      console.log('sortData', sortData);
      // if (filterOneTap.value !== 'all') {
      // if (filterOneTap.value === 'successful') {
      //   sortData = [...sortData].filter((item) => {
      //     const successCallItem = item.totalSucceededCalls;

      //     return successCallItem > 0;
      //   })
      //   // .map(item=>({...item,totalFailedCalls:0}));
      // }

      // if (filterOneTap.value === 'unsuccessful') {
      //   sortData = [...sortData].filter((item) => {
      //     const unSuccessCallItem = item.totalFailedCalls;

      //     return unSuccessCallItem > 0;
      //   })
      //   // .map(item=>({...item,totalSucceededCalls:0}));
      // }
      // if (filterOneTap.value === 'oneTap') {
      //   sortData = [...sortData].filter(
      //     (item) =>
      //       !!item.linkActionType?.oneTap ||
      //       !!item.linkActionType?.autoAccepted ||
      //       !!item.linkActionType?.autoDeclined
      //   );
      // }
      // if (filterOneTap.value === 'interactions') {
      //   sortData = [...sortData].filter((item) => {
      //     // const successCallItem = item.totalSucceededCalls;
      //     return (
      //       (!!item.linkActionType?.oneTap ||
      //         !!item.linkActionType?.autoAccepted ||
      //         !!item.linkActionType?.autoDeclined)
      //       // !!successCallItem
      //     );
      //   });
      // }
      // }

      console.log('sortData', filterOneTap.value, sortData);

      setAnalyticsData(
        sortData?.map(
          ({
            Number,
            PercentageConnected,
            Total,
            day,
            linkActionType,
            totalSucceededCalls,
            totalFailedCalls,
          }) => ({
            phoneNumber: formatPhoneDisplay(Number),
            percent: PercentageConnected?.toFixed(2),
            total: dataTotalFilter({
              PercentageConnected,
              Total,
              linkActionType,
              totalFailedCalls,
              totalSucceededCalls,
            }),
            totalSucceededCalls,
            totalFailedCalls,
            linkActionType,
            date: moment.isDate(day) ? moment(day).format('MM-DD-YYYY') : day,
            oneTap: linkActionType?.oneTap || 0,
            autoAccepted: linkActionType?.autoAccepted || 0,
            autoDeclined: linkActionType?.autoDeclined || 0,
            totalLink:
              (linkActionType?.oneTap || 0) +
              (linkActionType?.autoAccepted || 0) +
              (linkActionType?.autoDeclined || 0),
            Total,
          })
        ) || []
      );

      setAccountInformation(sortData);
      sortData.forEach((item, index) => {
        const totalAfterFilter = dataTotalFilter(item);
        if (selectedContact && selectedContact.length === 0) {
          const isOneTapAction =
            !!item.linkActionType?.oneTap ||
            !!item.linkActionType?.autoAccepted ||
            !!item.linkActionType?.autoDeclined;

          if (item.linkActionType) {
            autoAccepted += item.linkActionType.autoAccepted;
            autoDeclined += item.linkActionType.autoDeclined;
            oneTap += item.linkActionType.oneTap;
          }
          // if (item.duration > 5) {
          //   successCall += item.Total;
          // } else {
          //   unSuccessCall += item.Total;
          // }
          let currentSuccessCall = item.totalSucceededCalls;

          successCall += currentSuccessCall;
          unSuccessCall += item.totalFailedCalls;
          if (dayLabels.includes(moment(item.day).format('MM/DD/YYYY'))) {
            let index = dayLabels.findIndex(
              (el) => el === moment(item.day).format('MM/DD/YYYY')
            );
            if (index !== -1) {
              // callData[index] += item.Total;
              callData[index] += dataTotalGraph(item);
            }
          } else {
            dayLabels.push(moment(item.day).format('MM/DD/YYYY'));
            // callData.push(item.Total);
            callData.push(dataTotalGraph(item));
          }

          // if (isOneTapAction && !!currentSuccessCall) {
          successCallInteraction +=
          (currentSuccessCall * 2) + // Nhân đôi successful calls ở đây
          (item.linkActionType?.oneTap || 0) +
          (item.linkActionType?.autoAccepted || 0) +
          (item.linkActionType?.autoDeclined || 0);
          // }
        } else if (
          selectedContact &&
          selectedContact.includes(item.Number.replace('+', ''))
        ) {
          const isOneTapAction =
            !!item.linkActionType?.oneTap ||
            !!item.linkActionType?.autoAccepted ||
            !!item.linkActionType?.autoDeclined;

          if (item.linkActionType) {
            autoAccepted += item.linkActionType.autoAccepted;
            autoDeclined += item.linkActionType.autoDeclined;
            oneTap += item.linkActionType.oneTap;
          }
          // if (item.duration > 5) {
          //   successCall += item.Total;
          // } else {
          //   unSuccessCall += item.Total;
          // }

          let currentSuccessCall = item.totalSucceededCalls;
          successCall += currentSuccessCall;

          unSuccessCall += item.totalFailedCalls;
          if (dayLabels.includes(moment(item.day).format('MM/DD/YYYY'))) {
            let index = dayLabels.findIndex(
              (el) => el === moment(item.day).format('MM/DD/YYYY')
            );
            if (index !== -1) {
              // callData[index] += item.Total;
              callData[index] += dataTotalGraph(item);
            }
          } else {
            dayLabels.push(moment(item.day).format('MM/DD/YYYY'));
            // callData.push(item.Total);
            callData.push(dataTotalGraph(item));
          }

          // if (isOneTapAction && !!currentSuccessCall) {
          // successCallInteraction += 1;
         successCallInteraction +=
  (currentSuccessCall * 2) + // Nhân đôi successful calls ở đây
  (item.linkActionType?.oneTap || 0) +
  (item.linkActionType?.autoAccepted || 0) +
  (item.linkActionType?.autoDeclined || 0);
          // }
        }
      });
      setCallCount((old) => ({
        ...old,
        // total: callData.reduce((a, b) => a + b, 0) * 2,
        total: (successCall + unSuccessCall) * 2,
        successFull: successCall * 2,
        unSuccessFull: unSuccessCall * 2,
        autoAccepted,
        autoDeclined,
        oneTap,
        successCallInteraction,
      }));
      if (callData && callData.length > 0) {
        if ((Math.max(...callData) > 0) & (Math.max(...callData) <= 10)) {
          stepSizeForY = 2;
        }
        if ((Math.max(...callData) > 10) & (Math.max(...callData) <= 50)) {
          stepSizeForY = 5;
        }
        if ((Math.max(...callData) > 50) & (Math.max(...callData) <= 100)) {
          stepSizeForY = 10;
        }
        if (Math.max(...callData) > 100) {
          stepSizeForY = 50;
        }
      }
      console.log('callData', callData);

      setLineGraph({
        labels: [...dayLabels],
        datasets: [
          {
            label: '# of calls',
            data: [...callData],
            fill: false,
            backgroundColor: 'rgb(237, 226, 21)',
            borderColor: 'rgba(237, 147, 21, 0.55)',
          },
        ],
      });
      setOptionGraph({
        plugins: {
          legend: false,
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: stepSizeForY,
            },
            min: 0,
            max:
              callData && callData.length > 0
                ? Math.round(Math.max(...callData) / stepSizeForY) *
                    stepSizeForY +
                  stepSizeForY
                : 10,
          },
        },
      });
    }
  };

  const getGalleryAnalytics = async (contactDetails) => {
    let mobileNumbers = [];
    const queryData = {
      startTime: moment(startDate).format('x'),
      endTime: moment(endDate).format('x'),
      timezone: 'UTC',
    };
    const response = await galleryAnalytics(queryData);
    if (response.status === 200) {
      let newObj = [];
      response.data.objects &&
        response.data.objects.forEach((obj1) => {
          mobileNumbers.push(obj1.phone.replace(' ', ''));
          const test =
            contactDetails &&
            contactDetails.find(
              (obj2) => obj2.phone[0] === obj1.phone.replace(' ', '')
            );
          if (test) {
            newObj.push({ ...obj1, regions: test.regions });
          } else {
            newObj.push({ ...obj1, regions: [] });
          }
        });
      setGalleryAnalyticTable(newObj);
    }
    contactDetails &&
      contactDetails.map(async (item) => {
        if (mobileNumbers.includes(item.phone[0])) {
          if (item.galleryId) {
            const resImg = await getGalleryImage(item.galleryId);
            if (resImg.status === 200) {
              let base64ImageString = Buffer.from(
                resImg.data,
                'binary'
              ).toString('base64');
              setContactImages((prevState) => ({
                ...prevState,
                [item.phone[0]]: 'data:image/jpeg;base64,' + base64ImageString,
              }));
            } else {
              setContactImages((prevState) => ({
                ...prevState,
                [item.phone[0]]: noUser,
              }));
            }
          }
        }
      });
  };

  const fetchContactDetails = async () => {
    const data = { q: '*' };
    const res = await searchContacts(data);
    let contactArray = new Map();
    if (res.status === 200) {
      res.data.objects &&
        res.data.objects.forEach((item, index) => {
          item.phone.forEach((phn) => {
            contactArray.set(phn, {
              value: phn,
              label: phn,
            });
          });
        });
      setContactArray(res.data.objects);
      getGalleryAnalytics(res.data.objects);
    }

    setContactData([...contactArray.values()]);
  };

  const setSelectedVal = (option) => {
    let contactIdArray = [];
    if (option.length > 0) {
      option.forEach((item) => {
        if (item.value === 'all') {
          // contactData.forEach((itm) => {
          //   contactIdArray.push(itm.value);
          // });
          setSelectedContact(contactIdArray);
        } else {
          contactIdArray.push(item.value);
          setSelectedContact(contactIdArray);
        }
      });
    } else {
      setSelectedContact([]);
    }
  };

  const filterGraphData = async () => {
    setIsLoadingFilter(true);
    try {
      await getAnalytics();
      await getGalleryAnalytics(contactArray);
    } catch (error) {
    } finally {
      setIsLoadingFilter(false);
    }
  };

  function exportGraphData() {
    // console.log('lineGraph', lineGraph);

    // const rowData = [];
    // lineGraph?.labels?.forEach((label) => {
    //   rowData.push({
    //     date: label,
    //   });
    // });

    // lineGraph?.datasets?.[0]?.data?.forEach((value, index) => {
    //   rowData[index] = { ...rowData[index], total: value };
    // });

    handleExportGraph(
      analyticsData.map((item) => ({
        ...item,
        total: dataTotalGraph(item),
      }))
    );
  }

  function exportAnswerRate() {
    const rowData = analyticsData?.map(
      ({
        date,
        phoneNumber,
        total,
        percent,
        oneTap,
        autoAccepted,
        autoDeclined,
        totalLink,
        totalFailedCalls,
        totalSucceededCalls,
      }) => {
        // total = total*2;
        // oneTap = oneTap*2;
        // autoAccepted = autoAccepted*2;
        // autoDeclined = autoDeclined*2;
        // totalLink = totalLink*2;
        // totalFailedCalls = totalFailedCalls*2;
        // totalSucceededCalls = totalSucceededCalls*2;
        // totalFailedCalls
        // totalSucceededCalls
        const totalAndroid =
          totalPercentage.android > 0
            ? Math.round((total * totalPercentage.android) / 100)
            : 0;

        const totalIOS =
          totalPercentage.ios > 0
            ? Math.round((total * totalPercentage.ios) / 100)
            : 0;

        const totalSuccessful = totalSucceededCalls;
        const totalUnSuccessful = totalFailedCalls;

        const percentOne =
          totalLink > 0 ? ((totalLink * 100) / total).toFixed(2) : 0;
        // const percentAutoAccepted =
        //   autoAccepted > 0
        //     ? ((autoAccepted * 100) / totalLink).toFixed(2)
        //     : 0;
        // const percentAutoDeclined =
        //   autoDeclined > 0
        //     ? ((autoDeclined * 100) / totalLink).toFixed(2)
        //     : 0;
        const percentOneTap =
          oneTap > 0 ? ((oneTap * 100) / total).toFixed(2) : 0;

        // autoAccepted: (linkActionType?.autoAccepted || 0),
        //   autoDeclined: (linkActionType?.autoDeclined || 0),
        //   totalLink: (linkActionType?.oneTap || 0) + (linkActionType?.autoAccepted || 0) + (linkActionType?.autoDeclined || 0)

        // successCall += parseInt(
        //   (item.Total * item.PercentageConnected) / 100
        // );

        // percent

        let successCallInteraction = 0;
        // if (!!totalLink && !!totalSuccessful) {
        successCallInteraction +=
          totalSuccessful +
        (oneTap || 0) +
        (autoAccepted || 0) +
        (autoDeclined || 0);
        // }

        return {
          phoneNumber,
          total,
          totalAndroid,
          totalIOS,
          totalSuccessful,
          successfulPercent:
            totalSuccessful > 0
              ? ((totalSuccessful * 100) / total).toFixed(2)
              : 0,
          totalUnSuccessful,
          unSuccessfulPercent:
            totalUnSuccessful > 0
              ? ((totalUnSuccessful * 100) / total).toFixed(2)
              : 0,
          date,
          oneTap,
          percentOneTap,
          autoAccepted,
          autoDeclined,
          totalLink,
          percentOne,
          percentAutoAccepted,
          percentAutoDeclined,
          successCallInteraction,
          successCallInteractionPercent:
            successCallInteraction > 0
              ? ((successCallInteraction * 100) / total).toFixed(2)
              : 0,
        };
      }
    );

    // columns: [
    //   {
    //     name: 'Total',
    //     key: 'total',
    //   },
    //   {
    //     name: 'Android',
    //     key: 'totalAndroid',
    //   },
    //   {
    //     name: 'IOS',
    //     key: 'totalIOS',
    //   },
    //   {
    //     name: 'Successful Calls',
    //     key: 'totalSuccessful',
    //   },
    //   {
    //     name: 'Successful percent',
    //     key: 'successfulPercent',
    //   },
    //   {
    //     name: 'Unsuccessful Calls',
    //     key: 'totalUnSuccessful',
    //   },
    //   {
    //     name: 'Unsuccessful percent',
    //     key: 'unSuccessfulPercent',
    //   },
    //   {
    //     name: 'Date',
    //     key: 'date',
    //   },
    // ]

    // const rowData = [
    //   {
    //     type: 'Total',
    //     totalCalls: callCount.total,
    //     successfulCalls: callCount.successFull,
    //     successfulPercent: `${callSuccessRete > 0 ? callSuccessRete : 0}%`,

    //     unSuccessfulCalls: callCount.unSuccessFull,
    //     unSuccessfulPercent: `${
    //       callUnsuccessRete > 0 ? callUnsuccessRete : 0
    //     }%`,
    //   },

    //   {
    //     type: 'Android',
    //     totalCalls:
    //       totalPercentage.android > 0
    //         ? Math.round((callCount.total * totalPercentage.android) / 100)
    //         : 0,
    //     successfulCalls:
    //       totalPercentage.android && callSuccessRete
    //         ? Math.round(
    //             (Math.floor((callCount.total * totalPercentage.android) / 100) *
    //               callSuccessRete) /
    //               100
    //           )
    //         : 0,

    //     successfulPercent: `${callSuccessRete > 0 ? callSuccessRete : 0}%`,

    //     unSuccessfulCalls:
    //       totalPercentage.android && callUnsuccessRete
    //         ? Math.round(
    //             (Math.floor((callCount.total * totalPercentage.android) / 100) *
    //               callUnsuccessRete) /
    //               100
    //           )
    //         : 0,

    //     unSuccessfulPercent: `${
    //       callUnsuccessRete > 0 ? callUnsuccessRete : 0
    //     }%`,
    //   },

    //   {
    //     type: 'IOS',
    //     totalCalls:
    //       totalPercentage.ios > 0
    //         ? Math.round((callCount.total * totalPercentage.ios) / 100)
    //         : 0,
    //     successfulCalls:
    //       totalPercentage.ios && callSuccessRete
    //         ? Math.round(
    //             (Math.floor((callCount.total * totalPercentage.ios) / 100) *
    //               callSuccessRete) /
    //               100
    //           )
    //         : 0,

    //     successfulPercent: `${callSuccessRete > 0 ? callSuccessRete : 0}%`,

    //     unSuccessfulCalls:
    //       totalPercentage.ios && callUnsuccessRete
    //         ? Math.round(
    //             (Math.floor((callCount.total * totalPercentage.ios) / 100) *
    //               callUnsuccessRete) /
    //               100
    //           )
    //         : 0,

    //     unSuccessfulPercent: `${
    //       callUnsuccessRete > 0 ? callUnsuccessRete : 0
    //     }%`,
    //   },
    // ];

    handleExportAnswerRate(rowData);
  }

  const columns = [
    {
      name: 'Phone Number',
      selector: (row) => row['phone'],
    },
    {
      name: 'Total Downloads',
      selector: (row) => row['Total'],
    },
    {
      name: 'Regions',
      cell: (row) => {
        return (
          <div>
            {row?.regions?.length > 0 ? (
              <span>{row.regions.join(', ')}</span>
            ) : (
              '-'
            )}
          </div>
        );
      },
    },
    {
      name: 'Contact Profile',
      cell: (row) => {
        return (
          <img
            className='table-user-img'
            style={{ cursor: 'pointer' }}
            src={
              contactImages && contactImages[row['phone'].replace(' ', '')]
                ? contactImages[row['phone'].replace(' ', '')]
                : noUser
            }
            alt=''
          />
        );
      },
    },
  ];

  const totalTaplink =
    (callCount?.oneTap || 0) +
    (callCount.autoAccepted || 0) +
    (callCount.autoDeclined || 0);

  // const percentOne =
  //   callCount?.oneTap > 0
  //     ? ((callCount.oneTap * 100) / totalTaplink).toFixed(2)
  //     : 0;
  const percentAutoAccepted =
    callCount?.autoAccepted > 0
      ? ((callCount.autoAccepted * 100) / totalTaplink).toFixed(2)
      : 0;
  const percentAutoDeclined =
    callCount?.autoDeclined > 0
      ? ((callCount.autoDeclined * 100) / totalTaplink).toFixed(2)
      : 0;
  const percentTotalLink =
    totalTaplink > 0 ? ((totalTaplink * 100) / callCount.total).toFixed(2) : 0;
  const percentInteraction =
    callCount.successCallInteraction > 0
      ? ((callCount.successCallInteraction * 100) / callCount.total).toFixed(2)
      : 0;

  return (
    <div id='pageWrapper'>
      <div className='main-page'>
        <div className='page-wrapper'>
          <section className='dashboard-sec common-sec'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-12 col-md-12 col-lg-8'>
                  {/* <div className='card dashboard-chart-card dashboard-chart-card-header'>
                    
                  </div> */}
                  <div className='card dashboard-chart-card'>
                    <div
                      className='home_ana_theader card-header'
                      style={{ display: 'flex' }}>
                      <div>
                        <label>From Date</label>
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          placeholderText='From Date...'
                          maxDate={endDate}
                          dateFormat='MM/dd/yyyy'
                        />
                      </div>
                      <div>
                        <label>To Date</label>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          selectsEnd
                          placeholderText='To Date...'
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate}
                          dateFormat='MM/dd/yyyy'
                        />
                      </div>

                      <div className='flex-1'>
                        <label>Phone Numbers</label>
                        <Select
                          isMulti
                          name='contactId'
                          className='basic-multi-select basic_multi_cs'
                          classNamePrefix='select'
                          value={
                            contactData &&
                            contactData.filter(
                              (e) =>
                                selectedContact &&
                                selectedContact.includes(e.value)
                            )
                          }
                          options={[
                            { label: 'Select All', value: 'all' },
                            ...contactData,
                          ]}
                          onChange={(opt) => setSelectedVal(opt)}
                        />
                      </div>
                      <div className='flex-1'>
                        <label>Interactions</label>
                        <Select
                          // styles={{
                          //   width: '200px',
                          // }}
                          // className='basic-multi-select basic_multi_cs'
                          styles={{
                            container: (baseStyles, state) => ({
                              ...baseStyles,
                              // maxHeight: '32px',
                              // borderColor: state.isFocused ? 'grey' : 'red',
                            }),
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              height: '32px',
                              minHeight: '32px',
                              fontSize: '16px',
                            }),
                            input: (baseStyles, state) => ({
                              ...baseStyles,
                              margin: '0px',
                              padding: '0px',
                            }),
                            indicatorsContainer: (baseStyles, state) => ({
                              ...baseStyles,
                              height: '30px',
                            }),
                          }}
                          classNamePrefix='select'
                          value={filterOneTap}
                          options={optionFilterOneTap}
                          onChange={(opt) => setFilterOneTap(opt)}
                        />
                      </div>
                      <div className='d-flex'>
                        <button
                          className='btn btn-primary me-2'
                          onClick={() => filterGraphData()}>
                          Filter
                        </button>
                        <button
                          disabled={isLoadingFilter}
                          className='btn btn-primary'
                          onClick={exportGraphData}>
                          Export
                        </button>
                      </div>
                    </div>
                    <div className='card-body'>
                      <div className='dashboard-chart'>
                        {lineGraph &&
                          Object.keys(lineGraph).length > 0 &&
                          optionGraph &&
                          Object.keys(optionGraph).length > 0 && (
                            <Line data={lineGraph} options={optionGraph} />
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col col-md-12 col-lg-4 homeR-details'>
                  <div className='card account-info-card account-info-card-cs acc-info-card'>
                    <div className='card-header'>
                      <h2 className='title'>Interactions Rates</h2>
                      <button
                        disabled={isLoadingFilter}
                        className='btn btn-primary'
                        onClick={exportAnswerRate}>
                        Export
                      </button>
                    </div>
                    <div className='cs_ans_rates card-body'>
                      <div className='acc-info-wrap'>
                        <ul className='box-card'>
                          {/* For Total call calculation */}

                          <li className='success'>
                            <label className='cs_label'>Total calls</label>
                            <span className='cs_count'>{callCount.total}</span>
                          </li>
                          <li className='success'>
                            <label className='cs_label'>Successful calls</label>
                            <span className='cs_count'>
                              {callCount.successFull}
                            </span>
                            <div className='cs_range_slider'>
                              <div className='range_slider_wrap'>
                                <span
                                  className='range_slider_value'
                                  style={{
                                    width: `${
                                      callSuccessRete > 0 ? callSuccessRete : 0
                                    }%`,
                                  }}></span>
                              </div>
                              <p className='p_text_value'>
                                {callSuccessRete > 0 ? callSuccessRete : 0}%
                              </p>
                            </div>
                          </li>
                          <li className='unsuccess'>
                            <label className='cs_label'>
                              Unsuccessful calls
                            </label>
                            <span className='cs_count'>
                              {/* Number of calls :  */}
                              {callCount.unSuccessFull}
                            </span>
                            <div className='cs_range_slider'>
                              <div className='range_slider_wrap'>
                                <span
                                  className='range_slider_value'
                                  style={{
                                    width: `${
                                      callUnsuccessRete > 0
                                        ? callUnsuccessRete
                                        : 0
                                    }%`,
                                  }}></span>
                              </div>
                              <p className='p_text_value'>
                                {callUnsuccessRete > 0 ? callUnsuccessRete : 0}%
                              </p>
                            </div>
                          </li>

                          <li className='oneTap'>
                            <label className='cs_label'>1-Tap Actions</label>
                            <span className='cs_count'>
                              {/* Number of calls :  */}
                              {totalTaplink}
                            </span>
                            <div className='cs_range_slider'>
                              <div className='range_slider_wrap'>
                                <span
                                  className='range_slider_value'
                                  style={{
                                    width: `${
                                      percentTotalLink > 0
                                        ? percentTotalLink
                                        : 0
                                    }%`,
                                  }}></span>
                              </div>
                              <p className='p_text_value'>
                                {percentTotalLink > 0 ? percentTotalLink : 0}%
                              </p>
                            </div>
                          </li>

                          <li className='interaction'>
                            <label className='cs_label'>Interactions</label>
                            <span className='cs_count'>
                              {/* Number of calls :  */}
                              {callCount.successCallInteraction}
                            </span>
                            <div className='cs_range_slider'>
                              <div className='range_slider_wrap'>
                                <span
                                  className='range_slider_value'
                                  style={{
                                    width: `${
                                      percentInteraction > 0
                                        ? percentInteraction
                                        : 0
                                    }%`,
                                  }}></span>
                              </div>
                              <p className='p_text_value'>
                                {percentInteraction > 0
                                  ? percentInteraction
                                  : 0}
                                %
                              </p>
                            </div>
                          </li>

                          {/* <div
                            className='success'
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              width: '100%',
                              padding: '0px 4px',
                            }}>
                            <label className='cs_label'>
                              Interactions
                            </label>
                            <span
                              style={{ fontWeight: 'bold' }}
                              className='cs_count'>
                              {callCount.successCallInteraction}
                            </span>
                          </div> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className='card account-info-card account-info-card-cs acc-info-card'>
                    {/* <div className='card-header'>
                      <h2 className='title'>Answer Rates</h2>
                    </div> */}
                    <div className='cs_ans_rates card-body'>
                      <div className='acc-info-wrap'>
                        <ul className='box-card'>
                          {/* For android call calculation */}

                          <li className='success' style={{ display: 'flex' }}>
                            <label className='cs_label'>
                              Total Android calls
                            </label>
                            <span className='cs_count'>
                              {totalPercentage.android > 0
                                ? Math.round(
                                    (callCount.total *
                                      totalPercentage.android) /
                                      100
                                  )
                                : 0}
                            </span>
                          </li>
                          <li className='success'>
                            <label className='cs_label'>
                              Android Successful calls
                            </label>
                            <span className='cs_count'>
                              {totalPercentage.android && callSuccessRete
                                ? Math.round(
                                    (Math.floor(
                                      (callCount.total *
                                        totalPercentage.android) /
                                        100
                                    ) *
                                      callSuccessRete) /
                                      100
                                  )
                                : 0}
                            </span>
                            <div className='cs_range_slider'>
                              <div className='range_slider_wrap'>
                                <span
                                  className='range_slider_value'
                                  style={{
                                    width: `${
                                      callSuccessRete > 0 ? callSuccessRete : 0
                                    }%`,
                                  }}></span>
                              </div>
                              <p className='p_text_value'>
                                {callSuccessRete > 0 ? callSuccessRete : 0}%
                              </p>
                            </div>
                          </li>
                          <li className='unsuccess'>
                            <label className='cs_label'>
                              Android Unsuccessful calls
                            </label>
                            <span className='cs_count'>
                              {totalPercentage.android && callUnsuccessRete
                                ? Math.round(
                                    (Math.floor(
                                      (callCount.total *
                                        totalPercentage.android) /
                                        100
                                    ) *
                                      callUnsuccessRete) /
                                      100
                                  )
                                : 0}
                            </span>
                            <div className='cs_range_slider'>
                              <div className='range_slider_wrap'>
                                <span
                                  className='range_slider_value'
                                  style={{
                                    width: `${
                                      callUnsuccessRete > 0
                                        ? callUnsuccessRete
                                        : 0
                                    }%`,
                                  }}></span>
                              </div>
                              <p className='p_text_value'>
                                {callUnsuccessRete > 0 ? callUnsuccessRete : 0}%
                              </p>
                            </div>
                          </li>
                        </ul>
                        <ul className='box-card'>
                          {/* For ios call calculation */}
                          <li className='success'>
                            <label className='cs_label'>Total iOS calls*</label>
                            <span className='cs_count'>
                              {totalPercentage.ios > 0
                                ? Math.round(
                                    (callCount.total * totalPercentage.ios) /
                                      100
                                  )
                                : 0}
                            </span>
                          </li>
                          <li className='success'>
                            <label className='cs_label'>
                              iOS Successful calls
                            </label>
                            <span className='cs_count'>
                              {totalPercentage.ios && callSuccessRete
                                ? Math.round(
                                    (Math.floor(
                                      (callCount.total * totalPercentage.ios) /
                                        100
                                    ) *
                                      callSuccessRete) /
                                      100
                                  )
                                : 0}
                            </span>
                            <div className='cs_range_slider'>
                              <div className='range_slider_wrap'>
                                <span
                                  className='range_slider_value'
                                  style={{
                                    width: `${
                                      callSuccessRete > 0 ? callSuccessRete : 0
                                    }%`,
                                  }}></span>
                              </div>
                              <p className='p_text_value'>
                                {callSuccessRete > 0 ? callSuccessRete : 0}%
                              </p>
                            </div>
                          </li>
                          <li className='unsuccess'>
                            <label className='cs_label'>
                              iOS Unsuccessful calls
                            </label>
                            <span className='cs_count'>
                              {totalPercentage.ios && callUnsuccessRete
                                ? Math.round(
                                    (Math.floor(
                                      (callCount.total * totalPercentage.ios) /
                                        100
                                    ) *
                                      callUnsuccessRete) /
                                      100
                                  )
                                : 0}
                            </span>
                            <div className='cs_range_slider'>
                              <div className='range_slider_wrap'>
                                <span
                                  className='range_slider_value'
                                  style={{
                                    width: `${
                                      callUnsuccessRete > 0
                                        ? callUnsuccessRete
                                        : 0
                                    }%`,
                                  }}></span>
                              </div>
                              <p className='p_text_value'>
                                {callUnsuccessRete > 0 ? callUnsuccessRete : 0}%
                              </p>
                            </div>
                          </li>
                          <small className='estimated-badge'>*estimated </small>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className='card account-info-card account-info-card-cs acc-info-card'>
                    {/* <div className='card-header'>
                      <h2 className='title'>Answer Rates</h2>
                    </div> */}
                    <div className='cs_ans_rates card-body'>
                      <div className='acc-info-wrap'>
                        <div className='box-card box-card-new'>
                          {/* For android call calculation */}

                          <div
                            className='success'
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}>
                            <label className='cs_label'>
                              Total 1-Tap Clicks
                            </label>
                            <span className='cs_count'>{totalTaplink}</span>
                          </div>
                          {/* 
                          <div className='new-text'>
                            <label className=''>1-Tap Do Nothing</label>
                            <span className='cs_count'>
                              {callCount?.oneTap}
                            </span>
                          </div>
                          <div className='cs_range_slider tap-link other'>
                            <div className='range_slider_wrap'>
                              <span
                                className='range_slider_value tap-link-other'
                                style={{
                                  width: `${percentOne > 0 ? percentOne : 0}%`,
                                }}></span>
                            </div>
                            <p className='p_text_value'>
                              {percentOne > 0 ? percentOne : 0}%
                            </p>
                          </div>

                          <div className='new-text'>
                            <label className=''>1-Tap Auto Received</label>
                            <span className='cs_count'>
                              {callCount?.autoAccepted}
                            </span>
                          </div>
                          <div className='cs_range_slider tap-link success'>
                            <div className='range_slider_wrap'>
                              <span
                                className='range_slider_value tap-link-success'
                                style={{
                                  width: `${
                                    percentAutoAccepted > 0
                                      ? percentAutoAccepted
                                      : 0
                                  }%`,
                                }}></span>
                            </div>
                            <p className='p_text_value'>
                              {percentAutoAccepted > 0
                                ? percentAutoAccepted
                                : 0}
                              %
                            </p>
                          </div>

                          <div className='new-text'>
                            <label className=''>1-Tap Auto Declined</label>
                            <span className='cs_count'>
                              {callCount?.autoDeclined}
                            </span>
                          </div>
                          <div className='cs_range_slider tap-link unsuccess'>
                            <div className='range_slider_wrap'>
                              <span
                                className='range_slider_value tap-link-unsuccess'
                                style={{
                                  width: `${
                                    percentAutoDeclined > 0
                                      ? percentAutoDeclined
                                      : 0
                                  }%`,
                                }}></span>
                            </div>
                            <p className='p_text_value'>
                              {percentAutoDeclined > 0
                                ? percentAutoDeclined
                                : 0}
                              %
                            </p>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className='card account-info-card account-info-card-cs acc-info-card'>
                    <div className='cs_ans_rates card-body'>
                      <div className='acc-info-wrap'>
                        <div className='box-card box-card-new'>
                          <div
                            className='success'
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}>
                            <label className='cs_label'>
                              Total Successful Customer Interactions
                            </label>
                            <span className='cs_count'>
                              {callCount.successCallInteraction}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>

              {/* Hiding gallery analytics */}
              <div className='row' style={{ display: 'none' }}>
                <div className='col-12'>
                  <div
                    className='card dashboard-chart-card'
                    style={{ marginTop: '20px' }}>
                    <div className='card-header'>
                      <div className='card-header-inner'>
                        <div className='card-header-inner-left'>
                          <h2>Gallery Analytics Data</h2>
                        </div>
                      </div>
                    </div>
                    <div className='card-body'>
                      <div className='contact-data contact-data-table common-data-table gallery-analytics'>
                        <TableComponent
                          // title='Gallery Analytics Data'
                          columns={columns}
                          data={galleryAnalyticTable}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <FooterEnd />
    </div>
  );
};

const mapStateToProps = ({
  authReducer: { user, userRole },
  percentageReducer: { totalPercentage },
}) => ({
  tenantId: user.tenantId,
  userRole: userRole,
  totalPercentage: totalPercentage,
});

const mapDispatchToProps = (dispatch) => ({
  setTenant: (data) => dispatch(setTenant(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
